var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45318 0.953346C6.51434 0.864519 6.59618 0.79189 6.69164 0.741715C6.7871 0.691541 6.89333 0.665325 7.00118 0.665325C7.10903 0.665325 7.21526 0.691541 7.31072 0.741715C7.40618 0.79189 7.48802 0.864519 7.54918 0.953346L13.5492 9.62001C13.6186 9.71998 13.6594 9.83706 13.6669 9.95854C13.6745 10.08 13.6487 10.2013 13.5922 10.3091C13.5357 10.4169 13.4507 10.5072 13.3465 10.5701C13.2423 10.633 13.1229 10.6662 13.0012 10.666H1.00118C0.879741 10.6655 0.760737 10.6319 0.656966 10.5688C0.553194 10.5058 0.46858 10.4156 0.412224 10.308C0.355868 10.2004 0.329902 10.0796 0.337118 9.95833C0.344334 9.8371 0.384459 9.72014 0.453178 9.62001L6.45318 0.953346Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpVector);
export default __webpack_public_path__ + "static/media/upVector.5bdd940f42d6287778f3e1e5c3d932d6.svg";
export { ForwardRef as ReactComponent };